<template>
<div id="secure">

    <NewTopMenu />
    <div class="container">        
        <div class="columns">
            <div class="column is-12">
                <div class="card is-hidden1">
                    <div class="card-header" style="padding: 10px;">
                        <div class="columns">
                            <div class="column">
                                <loading :active.sync="isLoadingClasses" 
                                    :can-cancel="false" 
                                    :is-full-page="false">
                                </loading>
                                <b-select id="category" name="category" v-model="category" size="is-small" style="width: 200px;">
                                    <option selected value="school">All</option>
                                    <option v-for="kelas in kelasList" :key="kelas._id" :value="kelas._id">{{ kelas.level }} {{ kelas.name }}</option>
                                </b-select>
                            </div>
                            <div class="column">
                                <b-select id="displayType" name="displayType" v-model="displayType" size="is-small" @input="displayOptions()">
                                    <option selected value="1">By Behavior</option>
                                    <option value="2">By Tag (Summary)</option>
                                </b-select>
                            </div>
                            <div class="column" v-show="displayType == 1">
                                <loading :active.sync="isLoadingBehaviors" 
                                    :can-cancel="false" 
                                    :is-full-page="false">
                                </loading>
                                <b-select id="selectedBehaviorId" name="selectedBehaviorId" v-model="selectedBehaviorId" size="is-small" style="margin-left: 10px; width: 200px;">
                                    <option selected value="0">Select Behavior</option>
                                    <option v-for="behavior in behaviorList" :key="behavior._id" :value="behavior._id">{{ behavior.name }}</option>
                                </b-select>
                            </div>
                            <div class="column" v-show="displayType == 2">
                                <loading :active.sync="isLoadingTags" 
                                    :can-cancel="false" 
                                    :is-full-page="false">
                                </loading>
                                <b-select id="selectedTagId" name="selectedTagId" v-model="selectedTagId" size="is-small" style="margin-left: 10px; width: 200px;">
                                    <option selected value="0">Select Tag</option>
                                    <option v-for="tag in tagList" :key="tag._id" :value="tag._id">{{ tag.name }}</option>
                                </b-select>
                            </div>
                            <div class="column">
                                <b-select id="duration" name="duration" v-model="duration" size="is-small" style="margin-left: 10px;">
                                    <!-- <option selected value="daily" v-show="displayType == 1">Daily</option> -->
                                    <option selected value="range">Monthly</option>
                                    <option selected value="rangeDaily">Date Range</option>
                                    <option selected value="yearly" v-show="displayType == 2">Yearly</option> <!-- Utk by behavior, imin kena betulkan kat BE gak utk groupkan yearly data by month dulu  -->
                                </b-select>
                            </div>
                            <div class="column is-5" v-show="duration=='rangeDaily'">
                                <table style="margin-top: 3px;"><tr><td>
                                <datepicker v-model="rangeDailyStart" wrapper-class="datepicker" placeholder="Starting Date" :value="rangeDailyStart" :class="$style.datepicker" :calendar-button="true" calendar-button-icon="fa fa-calendar"></datepicker>
                                </td><td style="padding-right: 5px; padding-left: 5px; padding-top: 5px; font-size: 14px;">to</td><td>
                                <datepicker v-model="rangeDailyEnd" wrapper-class="datepicker" placeholder="Ending Date" :value="rangeDailyEnd" :class="$style.datepicker" :calendar-button="true" calendar-button-icon="fa fa-calendar"></datepicker>
                                </td></tr></table>
                            </div>
                            <div class="column" v-show="(duration=='range') || (duration=='yearly')">
                                 <!-- @closed="getSubmissionsByDuration(1)"   -->
                                <b-select id="durationMonthly" name="durationMonthly" v-model="durationMonthly" size="is-small" style="margin-left: 10px;" v-show="duration=='range'">
                                    <option selected value="1">January</option>
                                    <option selected value="2">February</option>
                                    <option selected value="3">March</option>
                                    <option selected value="4">April</option>
                                    <option selected value="5">May</option>
                                    <option selected value="6">June</option>
                                    <option selected value="7">July</option>
                                    <option selected value="8">August</option>
                                    <option selected value="9">September</option>
                                    <option selected value="10">October</option>
                                    <option selected value="11">November</option>
                                    <option selected value="12">December</option>
                                </b-select>
                                <b-select id="year" name="year" v-model="year" size="is-small" style="margin-left: 10px;" v-show="duration=='yearly'">
                                    <option :value="lastYear">{{ lastYear }}</option>
                                    <option selected :value="currentYear">{{ currentYear }}</option>
                                    <option :value="nextYear">{{ nextYear }}</option>
                                </b-select>
                            </div>
                        </div>
                    </div>
                    <div class="card-content" v-show="displayType == 1">
                        <center><b-button type="is-primary" v-on:click="generateChart()">Generate Chart</b-button></center>
                        <center><div class="block" v-show="chartGenerated">
                            <b-radio v-model="byTotalPointsOrCount" native-value="1" size="is-small" checked @input="refreshChart()">
                                Total Points
                            </b-radio>
                            <b-radio v-model="byTotalPointsOrCount" native-value="2" size="is-small" @input="refreshChart()">
                                Submission Count
                            </b-radio>
                            <b-radio v-model="byTotalPointsOrCount" native-value="3" size="is-small" @input="refreshChart()">
                                Number of Students
                            </b-radio>
                        </div></center>

                        <!-- <center><b-button type="is-info" size="is-small" v-on:click="generateExcel()">Download as Excel</b-button></center> -->
                        <loading :active.sync="isLoading1" 
                            :can-cancel="false" 
                            :is-full-page="false">
                        </loading>
                    </div>
                    <div class="card-content" v-show="displayType == 2">
                        <div class="columns" v-show="showProgressBar"><div class="column is-4"></div><div class="column is-2"><center><progress-bar
                            :options="pbOptions"
                            :value="pbValue"
                        /></center></div><div class="column is-4"></div></div>
                        <center>Please click the 'Download Summary' button below to download the summary in Excel format.</center>
                        <br/>
                        <center><a class="button is-primary" v-on:click="generateExcelSummary(1)">Download Summarized Marks in Excel</a></center><br/>
                        <center><a class="button is-primary" v-on:click="generateExcelSummary(2)">Download Summarized Marks with Detailed Items in Excel</a></center>
                        <loading :active.sync="isLoading1" 
                            :can-cancel="false" 
                            :is-full-page="false">
                        </loading>
                    </div>
                    <div class="card-content" v-show="displayType == 1">                        
                        <!-- <div style="text-align: center !important;">Chart below will display the total number of students that was awarded the selected behavior</div> -->
                        <loading :active.sync="isLoading" 
                            :can-cancel="false" 
                            :is-full-page="true">
                        </loading>
                        <div class="columns">
                            <div class="column is-10">
                                <!-- <horizontal-bar-chart
                                    :behaviorID="behaviorID"
                                    :behaviorName="behaviorName" :behaviorColor="behaviorColor" :submissionData="submissionData" v-if="isSubmissionDataAvailable" :width="800"
                                    :height="chartHeight"
                                    :key="viewChartKey" :category="category" :duration="duration" :durationDaily="selectedDate" :durationMonthly="durationMonthly" :durationYearly="durationYearly" v-show="category != 'behavior'"></horizontal-bar-chart> -->                                    
                                <bar-chart
                                    :dataTitle="dataTitle"
                                    :behaviorID="selectedBehaviorId" :behaviorName="selectedBehaviorName" :behaviorColor="selectedBehaviorColor"
                                    :labelList="chartLabelList" :dataList="chartDataList" :duration="barDuration" :startDate="startDate" :endDate="endDate" :year="year"
                                    :category="category" :labelListOriginal="chartLabelListOriginal"
                                    v-if="isSubmissionDataAvailable" :width="800"
                                    :key="selectedBehaviorChartKey"></bar-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NewTopMenu from "./NewTopMenu";
import axios from "axios";
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Datepicker from 'vuejs-datepicker';
import "./public/style.scss";
import HorizontalBarChart from './Charts/HorizontalBarChart'
import BarChart from './Charts/BarChart'
const helper = require("../../config/helper")

export default {
    name: "OverallAnalysisTest",
    components: {
        NewTopMenu,
        Loading,
        Datepicker,
        HorizontalBarChart,
        BarChart
    },
    data() {
        return {
            dataTitle: "",
            chartLabelList: [],
            chartLabelListOriginal: [],
            chartDataList: [],
            chartTotalPointsList: [],
            chartSubmissionCountList: [],
            chartStudentCountList: [],
            chartGenerated: false,
            schoolID: "",
            kelasID: "",
            kelasList: [],
            behaviorList: [],
            dataList: [],
            isLoading: false,
            isLoading1: false,
            isLoadingBehaviors: false,
            isLoadingClasses: false,
            isLoadingTags: false,
            selectedDate: "",
            rangeDailyStart: "",
            rangeDailyEnd: "",
            todayDate: '',
            currentYear: 0,
            lastYear: 0,
            nextYear: 0,
            currentMonth: 0,
            currentDay: 0,
            category: "school",
            displayType: 1,
            duration: "range",
            durationDaily: "",
            durationMonthly: 0,
            startDate: "",
            endDate: "",
            year: 0,
            barDuration: "daily",
            lastRefresh: "",
            
            viewChartKey: "",
            isSubmissionDataAvailable: false,
            behaviorID: [],
            behaviorName: [],
            behaviorColor: [],
            submissionData: [],
            durationData: [],
            chartHeight: 600,
            byTotalPointsOrCount: 1,   //1 - total points, 2 - submission count

            selectedCategoryId: "", //used by category school and kelas

            selectedBehaviorId: "0",    //used by category behavior only
            selectedTagId: "0",
            selectedBehaviorName: "",   //used by category behavior only
            selectedBehaviorColor: "",  //used by category behavior only
            selectedBehaviorChartKey: "",   //used by category behavior only
            behaviorChartListDuration: [],  //used by category behavior only
            behaviorChartListDurationName: [],   //used by category behavior only

            tagList: [],
            showProgressBar: false,
            pbOptions: {
                text: {
                    color: '#FFFFFF',
                    shadowEnable: true,
                    shadowColor: '#000000',
                    fontSize: 14,
                    fontFamily: 'Helvetica',
                    dynamicPosition: false,
                    hideText: false
                },
                progress: {
                    color: '#2dbd2d',
                    backgroundColor: '#333333'
                },
                layout: {
                    height: 35,
                    width: 220,
                    verticalTextAlign: 61,
                    horizontalTextAlign: 43,
                    zeroOffset: 0,
                    strokeWidth: 30,
                    progressPadding: 0,
                    type: 'line'
                }
            },
            pbValue: 0

        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    created() {
        this.schoolID = localStorage.getItem('schoolID');
        var currentDate = new Date();
        this.currentDay = currentDate.getDate();
        if (currentDate.getDate() < 10){
            this.currentDay = "0" + this.currentDay;
        }
        this.currentYear = currentDate.getFullYear()        
        this.lastYear = this.currentYear - 1
        this.nextYear = this.currentYear + 1
        this.year = this.currentYear

        this.currentMonth = currentDate.getMonth() + 1;  //since month starts from 0
        this.attendanceSelectedMonth = this.currentMonth
        if (this.currentMonth < 10){
            this.currentMonth = "0" + this.currentMonth;
        }
        this.durationDaily = new Date(currentDate.getFullYear(),currentDate.getMonth(),currentDate.getDate())
        this.durationMonthly = currentDate.getMonth() + 1;  //since month starts from 0
        this.durationYearly = this.currentYear
        this.selectedDate = currentDate.getFullYear() + "" + this.currentMonth + "" + this.currentDay;

        this.rangeDailyStart = new Date(this.currentYear, currentDate.getMonth(), currentDate.getDate())
        this.rangeDailyEnd = new Date(this.currentYear, currentDate.getMonth(), currentDate.getDate())

        this.getClassList()
        this.getBehaviorList()
        this.getTagList()
        // this.getSubmissionsByDuration(0)
    },
    mounted(){
    },
    methods: {
        displayOptions(){
            console.log("entering displayOptions with " + this.displayType)
            this.duration = "range"
        },
        refreshChart(){
            let self = this;
            if (self.byTotalPointsOrCount == 1){
                self.dataTitle = "Total Points"
                self.chartDataList = self.chartTotalPointsList
            }else if (self.byTotalPointsOrCount == 2){
                self.dataTitle = "Submissions"
                self.chartDataList = self.chartSubmissionCountList
            }else if (self.byTotalPointsOrCount == 3){
                self.dataTitle = "Students"
                self.chartDataList = self.chartStudentCountList
            }
            self.selectedBehaviorChartKey = self.byTotalPointsOrCount + self.category + self.selectedBehaviorId + self.duration + self.year + self.durationMonthly + new Date().getTime() //this will recreate the overall chart
        },
        async generateChart(){
            var self = this;
            if (self.selectedBehaviorId == 0){
                alert("Please select a behavior first.")
                return false;
            }
            var year = self.currentYear
            if (self.duration == "yearly"){
                //ni belum buat actually, sbb tu duration yearly hidden
                year = self.year
                var submissions = await self.getSubmissionData(true,year)
                this.barDuration = "monthly"    //since each bar will display total for a month
            }else if (self.duration == "range"){
                var strMonth = self.durationMonthly
                if (strMonth < 10){
                    strMonth = "0" + strMonth
                }
                var daysInMonth = helper.getDaysInMonth(self.durationMonthly,self.year)
                self.startDate = self.year + "" + strMonth + "01"
                self.endDate = self.year + "" + strMonth + "" + daysInMonth
                var submissions = await self.getSubmissionData(false,0,self.startDate,self.endDate)

                if (self.byTotalPointsOrCount == 1){
                    self.dataTitle = "Total Points"
                }else if (self.byTotalPointsOrCount == 2){
                    self.dataTitle = "Submissions"
                }else if (self.byTotalPointsOrCount == 3){
                    self.dataTitle = "Students"
                }
                this.barDuration = "daily"    //since each bar will display total for a day

                if (submissions.success){
                    self.isSubmissionDataAvailable = true

                    var findSelectedBehavior = self.selectedBehaviorId
                    let selectedBehaviorData = _.find(self.behaviorList, {'_id': findSelectedBehavior});
                    // self.selectedBehaviorColor = selectedBehaviorData.colour
                    self.selectedBehaviorColor = selectedBehaviorData.colour
                    self.selectedBehaviorName = selectedBehaviorData.name

                    self.selectedBehaviorChartKey = self.byTotalPointsOrCount + self.category + self.selectedBehaviorId + self.duration + self.year + self.durationMonthly + new Date().getTime() //this will recreate the overall chart

                    self.chartDataList = []
                    self.chartLabelList = []
                    self.chartLabelListOriginal = []
                    self.chartTotalPointsList = []
                    self.chartSubmissionCountList = []
                    self.chartStudentCountList = []
                    for (var i = 0; i < submissions.result.length; i++){
                        self.chartLabelList.push(submissions.result[i].displayDate)
                        self.chartLabelListOriginal.push(submissions.result[i].actionDate)
                        self.chartTotalPointsList.push(submissions.result[i].totalPoints)
                        self.chartSubmissionCountList.push(submissions.result[i].submissionCount)
                        self.chartStudentCountList.push(submissions.result[i].studentCount)
                    }
                    if (self.byTotalPointsOrCount == 1){
                        self.chartDataList = self.chartTotalPointsList
                        self.dataTitle = "Total Points"
                    }else if (self.byTotalPointsOrCount == 2){
                        self.chartDataList = self.chartSubmissionCountList
                        self.dataTitle = "Submissions"
                    }else if (self.byTotalPointsOrCount == 3){
                        self.dataTitle = "Students"
                        self.chartDataList = self.chartStudentCountList
                    }
                    self.chartGenerated = true

                }else{
                    self.isSubmissionDataAvailable = false
                    Toast.open({
                        message: "Server maybe handling too many requests now. Please try again later.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })                    
                }
                
            }else if (self.duration == "rangeDaily"){

                var startDay = this.rangeDailyStart.getDate()
                var startMonth = this.rangeDailyStart.getMonth() + 1
                var startYear = this.rangeDailyStart.getFullYear()
                if (startDay < 10){
                    startDay = "0" + startDay
                }
                if (startMonth < 10){
                    startMonth = "0" + startMonth
                }

                var endDay = this.rangeDailyEnd.getDate()
                var endMonth = this.rangeDailyEnd.getMonth() + 1
                var endYear = this.rangeDailyEnd.getFullYear()
                if (endDay < 10){
                    endDay = "0" + endDay
                }
                if (endMonth < 10){
                    endMonth = "0" + endMonth
                }

                self.startDate = startYear + "" + startMonth + "" + startDay                
                self.endDate = endYear + "" + endMonth + "" + endDay

                console.log("417 self.startDate: " + self.startDate)
                console.log("417 self.endDate: " + self.endDate)

                var submissions = await self.getSubmissionData(false,0,self.startDate,self.endDate)

                if (self.byTotalPointsOrCount == 1){
                    self.dataTitle = "Total Points"
                }else if (self.byTotalPointsOrCount == 2){
                    self.dataTitle = "Submissions"
                }else if (self.byTotalPointsOrCount == 3){
                    self.dataTitle = "Students"
                }
                this.barDuration = "daily"    //since each bar will display total for a day

                if (submissions.success){
                    self.isSubmissionDataAvailable = true

                    var findSelectedBehavior = self.selectedBehaviorId
                    let selectedBehaviorData = _.find(self.behaviorList, {'_id': findSelectedBehavior});
                    // self.selectedBehaviorColor = selectedBehaviorData.colour
                    self.selectedBehaviorColor = selectedBehaviorData.colour
                    self.selectedBehaviorName = selectedBehaviorData.name

                    self.selectedBehaviorChartKey = self.byTotalPointsOrCount + self.category + self.selectedBehaviorId + self.duration + self.startDate + self.endDate + new Date().getTime() //this will recreate the overall chart

                    self.chartDataList = []
                    self.chartLabelList = []
                    self.chartLabelListOriginal = []
                    self.chartTotalPointsList = []
                    self.chartSubmissionCountList = []
                    self.chartStudentCountList = []
                    for (var i = 0; i < submissions.result.length; i++){
                        self.chartLabelList.push(submissions.result[i].displayDate)
                        self.chartLabelListOriginal.push(submissions.result[i].actionDate)
                        self.chartTotalPointsList.push(submissions.result[i].totalPoints)
                        self.chartSubmissionCountList.push(submissions.result[i].submissionCount)
                        self.chartStudentCountList.push(submissions.result[i].studentCount)
                    }
                    if (self.byTotalPointsOrCount == 1){
                        self.chartDataList = self.chartTotalPointsList
                        self.dataTitle = "Total Points"
                    }else if (self.byTotalPointsOrCount == 2){
                        self.chartDataList = self.chartSubmissionCountList
                        self.dataTitle = "Submissions"
                    }else if (self.byTotalPointsOrCount == 3){
                        self.dataTitle = "Students"
                        self.chartDataList = self.chartStudentCountList
                    }
                    self.chartGenerated = true

                }else{
                    self.isSubmissionDataAvailable = false
                    Toast.open({
                        message: "Server maybe handling too many requests now. Please try again later.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })                    
                }
            }else{
                alert("Invalid duration!")  //nnt bole letak select by datepicker range kot
                return false;
            }
        },
        async getSubmissionData(isYearly,year,startDate,endDate){
            console.log("entering getSubmissionData with isYearly: " + isYearly + ", year: " + year + ", startDate: " + startDate + ", endDate: " + endDate)
            let self = this
            self.isLoading = true;
            axios.defaults.responseType = 'json'
            var getResult = await axios.post(process.env.MY_URL + '/submissionsV2/data', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                category: self.category,
                behaviorID: self.selectedBehaviorId,
                isYearly: isYearly,
                year: year,
                startDate: startDate,
                endDate: endDate,
                output: "",
                redis: 1
            })
            self.isLoading = false;
            return getResult.data;
        },
        async generateExcelSummary(summaryType){
            let self = this

            if (self.selectedTagId == 0){
                alert("Please select a tag first.")
                return false;
            }
            self.isLoading1 = true

            let selectedCategoryData = _.find(self.kelasList, {'_id': self.category});
            var categoryName = "";
            if (selectedCategoryData){
                categoryName = selectedCategoryData.level + " " + selectedCategoryData.name
            }
            
            this.$gtag.event('OverallAnalysis', {
                'event_category': 'ExcelSummary',
                'event_label': localStorage.getItem('schoolName'),
                'value': localStorage.getItem('schoolID')
            })

            if (self.duration == "yearly"){
                axios.defaults.responseType = 'json'
                var promises = []
                var tempValue = parseInt(self.currentMonth) + 1
                var currentProgress = tempValue
                currentProgress = 100/tempValue  //+1 since generating excel is the added 1
                console.log("tempValue: " + tempValue)
                console.log("currentProgress: " + currentProgress)
                self.showProgressBar = true;
                self.pbValue = 0

                try{
                    for (var month = 1; month <= self.currentMonth; month++){
                        var strMonth = month
                        if (strMonth < 10){
                            strMonth = "0" + strMonth
                        }
                        var daysInMonth = helper.getDaysInMonth(month,self.year)
                        var startDate = self.year + "" + strMonth + "01"
                        var endDate = self.year + "" + strMonth + "" + daysInMonth
                        
                        promises.push(await axios.post(process.env.MY_URL + '/submissionsV2/summary', {
                            token: localStorage.getItem('jwtTokenV2'),
                            email: localStorage.getItem('email'),
                            category: self.category,
                            categoryName: categoryName,
                            startDate: startDate,
                            endDate: endDate,
                            selectedTagId: self.selectedTagId,
                            summaryType: summaryType,
                            output: "json"
                        }))
                        this.pbValue = this.pbValue + currentProgress
                    }    
                }catch(e){
                    console.log("459 error:")
                    console.log(e)
                    self.isLoading1 = false
                    self.showProgressBar = false;
                    if (e.response.status === 418) {
                        Toast.open({
                            message: "Server is handling too many requests now. Please try again later.",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    }else if (e.response.status === 401) {                            
                        Toast.open({
                            message: "Unauthorized access. Please re-login.",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    } else {
                        Toast.open({
                            message: 'Error: ' + e.response.data.msg,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    }
                }         

                var yearlyStudentData = []
                var yearlySummary = await Promise.all(promises)

                //let's parse out the student data first
                for (var j = 0; j < yearlySummary[0].data.length; j++){
                    var studentActivityList = []
                    for (var k = 0; k < yearlySummary[0].data[j].activities.length; k++){
                        var activity = {
                            name : yearlySummary[0].data[j].activities[k].name,
                            behaviorPoints : yearlySummary[0].data[j].activities[k].behaviorPoints,
                            maxDailyCountOverall : yearlySummary[0].data[j].activities[k].maxDailyCountOverall,
                            totalPoints: 0,
                            averagePoints: 0,
                            submissionCount: 0
                        }
                        studentActivityList.push(activity)
                    }
                    var studentData = {
                        totalPoints: 0,
                        averagePoints: 0,
                        _id : yearlySummary[0].data[j]._id,
                        schoolID: yearlySummary[0].data[j].schoolID,
                        kelasID: yearlySummary[0].data[j].kelasID,
                        firstName: yearlySummary[0].data[j].firstName,
                        lastName: yearlySummary[0].data[j].lastName,
                        totalSubmissions: 0,
                        activities: studentActivityList
                    }
                    yearlyStudentData.push(studentData)
                }

                for (var i = 0; i < yearlySummary.length; i++){
                    for (var j = 0; j < yearlySummary[i].data.length; j++){
                        for (var k = 0; k < yearlySummary[i].data[j].activities.length; k++){
                            yearlyStudentData[j].totalPoints = yearlyStudentData[j].totalPoints + yearlySummary[i].data[j].activities[k].totalPoints
                            yearlyStudentData[j].totalSubmissions = yearlyStudentData[j].totalSubmissions + yearlySummary[i].data[j].activities[k].submissionCount

                            yearlyStudentData[j].activities[k].totalPoints = yearlyStudentData[j].activities[k].totalPoints + yearlySummary[i].data[j].activities[k].totalPoints
                            yearlyStudentData[j].activities[k].submissionCount = yearlyStudentData[j].activities[k].submissionCount + yearlySummary[i].data[j].activities[k].submissionCount
                        }
                        yearlyStudentData[j].averagePoints = yearlyStudentData[j].averagePoints + yearlySummary[i].data[j].averagePoints
                    }
                }
                for (var i = 0; i < yearlyStudentData.length; i++){
                    yearlyStudentData[i].averagePoints = yearlyStudentData[i].averagePoints / yearlySummary.length
                }
                console.log("ok sekarang hantar yearlyStudentData ke backend utk generate excel")

                let selectedCategoryData = _.find(self.kelasList, {'_id': self.category});
                var categoryName = "";
                if (selectedCategoryData){
                    categoryName = selectedCategoryData.level + " " + selectedCategoryData.name
                }

                axios.defaults.responseType = 'blob'
                axios.post(process.env.MY_URL + '/submissionsv2/summary/excel', {
                    token: localStorage.getItem('jwtTokenV2'),
                    email: localStorage.getItem('email'),
                    data: yearlyStudentData,
                    category: self.category,
                    categoryName: categoryName,
                    durationName: self.year + ""    //change to string since it will be processed as such in the BE
                })
                .then(response => {
                    this.pbValue = this.pbValue + currentProgress   //pbValue should be 100% here
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', "Summary Yearly.xlsx");
                    document.body.appendChild(link);
                    link.click();         
                    self.isLoading1 = false
                    self.showProgressBar = false;
                })
                .catch(e => {
                    console.log(e)
                    self.isLoading1 = false
                    self.showProgressBar = false;
                    if (e.response.status === 418) {
                        Toast.open({
                            message: "Server is handling too many requests now. Please try again later.",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    }else if (e.response.status === 401) {                            
                        Toast.open({
                            message: "Unauthorized access. Please re-login.",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    } else {
                        Toast.open({
                            message: 'Error: ' + e.response.data.msg,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    }
                })
                
            }else{
                var strMonth = self.durationMonthly
                if (strMonth < 10){
                    strMonth = "0" + strMonth
                }
                var daysInMonth = helper.getDaysInMonth(self.durationMonthly,self.year)
                self.startDate = self.year + "" + strMonth + "01"
                self.endDate = self.year + "" + strMonth + "" + daysInMonth
                
                axios.defaults.responseType = 'blob'
                axios.post(process.env.MY_URL + '/submissionsV2/summary', {
                    token: localStorage.getItem('jwtTokenV2'),
                    email: localStorage.getItem('email'),
                    category: self.category,
                    categoryName: categoryName,
                    startDate: self.startDate,
                    endDate: self.endDate,
                    selectedTagId: self.selectedTagId,
                    summaryType: summaryType,
                    output: "excel"
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', "Summary by users.xlsx");
                    document.body.appendChild(link);
                    link.click();         
                    self.isLoading1 = false
                })
                .catch(e => {
                    console.log(e)
                    self.isLoading1 = false                
                    if (e.response.status === 418) {
                        Toast.open({
                            message: "Server is handling too many requests now. Please try again later.",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    }else if (e.response.status === 401) {                            
                        Toast.open({
                            message: "Unauthorized access. Please re-login.",
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    } else {
                        Toast.open({
                            message: 'Error: ' + e.response.data.msg,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 5000
                        })
                    }
                })
            }            

        },
        generateExcel(){
            let self = this
            axios.defaults.responseType = 'blob'
            axios.post(process.env.MY_URL + '/exportToExcelV2/overallAnalysis', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                category: self.category,
                submissionData: self.submissionData,
                durationData: self.durationData,
                byTotalPointsOrCount: self.byTotalPointsOrCount
            })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', "Overall Behavior Analysis.xlsx");
                document.body.appendChild(link);
                link.click();         
                self.isLoading = false
            })
            .catch(e => {
                console.log(e)
                self.isLoading = false
                if (e.response.status === 401) {                            
                    Toast.open({
                        message: "Unauthorized access. Please re-login.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        message: 'Error: ' + e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
            })
        },
        timeDifference(ts1,ts2){
            //https://stackoverflow.com/questions/16767301/calculate-difference-between-2-timestamps-using-javascript?noredirect=1&lq=1
            var difference = ts1 - ts2;

            //var daysDifference = Math.floor(difference/1000/60/60/24);
            var hoursDifference = Math.floor(difference/1000/60/60);
            //var minutesDifference = Math.floor(difference/1000/60);

            return hoursDifference;
        },
        getMonthDisplay(month){
            month = parseInt(month)
            var monthDisplay = "";
            switch (month){
                case 0:
                    monthDisplay = "January";
                    break;
                case 1:
                    monthDisplay = "February";
                    break;
                case 2:
                    monthDisplay = "March";
                    break;
                case 3:
                    monthDisplay = "April";
                    break;
                case 4:
                    monthDisplay = "May";
                    break;
                case 5:
                    monthDisplay = "June";
                    break;
                case 6:
                    monthDisplay = "July";
                    break;
                case 7:
                    monthDisplay = "August";
                    break;
                case 8:
                    monthDisplay = "September";
                    break;
                case 9:
                    monthDisplay = "October";
                    break;
                case 10:
                    monthDisplay = "November";
                    break;
                case 11:
                    monthDisplay = "December";
                    break;
                default:
                    monthDisplay = "";
                    break;
            }
            return monthDisplay;
        },
        getClassList(){
            let self = this
            self.isLoadingClasses = true;
            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/classes/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
            })
            .then(response => {
                self.kelasList = response.data.kelasList
                self.isLoadingClasses = false;
            })
            .catch(e => {
                console.log(e)
                self.isLoadingClasses = false;
            })
        },
        getBehaviorList(){
            let self = this
            self.isLoadingBehaviors = true;
            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/behaviors/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
            })
            .then(response => {
                self.behaviorList = response.data
                self.isLoadingBehaviors = false;
            })
            .catch(e => {
                console.log(e)
                self.isLoadingBehaviors = false;
            })
        },
        getTagList(){            
            let self = this;
            self.isLoadingTags = true;
            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/behaviors/tagList/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
            })
            .then(response => {
                self.tagList = response.data
                self.isLoadingTags = false;
            })
            .catch(e => {
                console.log(e)
                self.isLoadingTags = false;
            })
        },
        roundTo2DecimalPlaces(points){  //use lodash to round the points to 2 decimal places
            return _.round(points, 2)
            // return _.round(points, 2).toFixed(2)
        },
    },
};
</script>

<style scoped>
.myDatepickerClass{
    margin-top: 2px;
    border: 1px dotted #000;
    width: 115%;
}
.container{
    padding: 10px;
}
.box{
    border: 1px solid #ccc;
    width: 40% !important;
    margin: 4px;
    padding: 0px !important;
}
.active{
    border: 1px solid rgb(6, 50, 247);
}
.vertical-center{
    display: flex;
    align-items: center;
}
.card-content{
    min-height: 200px;
}
</style>
<style module>
.datepicker input{
    border: none; /* <-- This thing here */
    border:1px solid #1849c8;
    border-radius: 5px;
    text-align: center;
    font-size: 14px;
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/OverallAnalysisTest.vue